import { localizePercent } from 'utils/l10n/percent';
import { Row } from '../components';
import { BaseLevelSnippetResp } from '../types';
import { getToggleLabel } from './generalUtils';

const getIsAtCampaignLimit = (count: number, showCampaigns: boolean) => showCampaigns && count > 50;

const getRow = (snip: BaseLevelSnippetResp, showCampaigns: boolean) => {
  const {
    id,
    name,
    urlCount,
    campaignCount,
    metrics: { TotalSent, TotalClicks, UniqueClicks, ClickRate },
  } = snip;
  const count = showCampaigns ? campaignCount : urlCount;
  const cells = [name, TotalSent, TotalClicks, UniqueClicks, localizePercent(ClickRate)];
  const toggleLabel = getToggleLabel(count, showCampaigns);
  const isAtCampaignLimit = getIsAtCampaignLimit(campaignCount, showCampaigns);

  return {
    id: id.toString(), // as a string to match breakdown id type
    row: (
      <Row
        cells={cells}
        snippetId={id}
        toggleLabel={toggleLabel}
        isExpandable
        isAtCampaignLimit={isAtCampaignLimit}
      />
    ),
    nestedData: [
      {
        id: `${id}-loading`,
        row: <Row cells={[]} isBreakdownLoadingRow />,
      },
    ],
  };
};

export const getBaseLevelTableRows = (
  baseLevelSnippetsResp: BaseLevelSnippetResp[],
  showCampaigns: boolean,
) => {
  return baseLevelSnippetsResp.map((snip) => getRow(snip, showCampaigns));
};
